import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, FormControlLabel, Menu, MenuItem } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
import {
  constant,
  decryptData,
  encryptData,
  logout,
  multiDecryption,
} from "../../utils/utils";
import useSelector from "../../store/selector";

import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Logout from "@mui/icons-material/Logout";
// import AccountBoxIcon from "@mui/icons-material/Person";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import "../../Style/Theme/index.css";
import ThemeMaterialUISwitch from "./ThemeMaterialUISwitch";

export default function Header({
  step,
  showBar,
  showMenu = false,
  disabledBackBtn = false,
  showLogoutBtn = true,
  showContactUs = true,
}) {
  const navigate = useNavigate();
  const { getRecoilVal, setRecoilVal } = useSelector();
  const [darkMode, setDarkMode] = useState(false);

  // console.log(
  //   "window events --------------",
  //   window.PerformanceNavigationTiming
  // );

  // let loginDetailPresent = false;
  // let loginDetail = {};
  // if (localStorage?.getItem("uslLoginDetail") !== null) {
  //   const {
  //     Anchor = null,
  //     Program = null,
  //     Source = null,
  //   } = JSON?.parse(localStorage?.getItem("uslLoginDetail"));
  //   loginDetailPresent = true;
  //   loginDetail.Anchor = Anchor;
  //   loginDetail.Program = Program;
  //   loginDetail.Source = Source;
  // }
  // const [isVisible, setIsVisible] = useState(true);
  const [anchorEl, setanchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const displayLogoutBtn = async () => {
    let data = getRecoilVal(constant.atomsName.USER_DETAIL);
    if (data) {
      return (
        (await decryptData(data[constant.LOGINLOGOUT_KEY])) ===
        constant.LOGIN_VALUE
      );
    }
    return false;
  };

  const displayLogoutBtn_old = () => {
    if (sessionStorage?.getItem("uslLoginDetail") !== null) {
      let loginDetail = JSON?.parse(sessionStorage?.getItem("uslLoginDetail"));
      return loginDetail[constant.LOGINLOGOUT_KEY] === constant.LOGIN_VALUE;
    }
    return false;
  };

  const handleLogout = async () => {
    setRecoilVal(constant?.atomsName?.GST_DETAILS, null);
    setRecoilVal(constant?.atomsName?.UDYAM_DETAILS, null);
    setRecoilVal(constant?.atomsName?.AADHAR_DETAILS, null);
    let userDetail = getRecoilVal(constant.atomsName.USER_DETAIL);
    let logoutValData = await logout(userDetail);
    setRecoilVal(constant.atomsName.USER_DETAIL, logoutValData);
    let logoutVal = await multiDecryption(logoutValData);
    // console.log("logoutvaaal------", logoutVal);
    // let logoutVal = logout();
    if (logoutVal?.screen === "pay") {
      //it will redirect to repayment login screen
      navigate(
        `/Pay/${logoutVal?.source}/${logoutVal?.anchor}/${logoutVal?.program}`,
        {
          replace: true,
        }
      );
    } else {
      //it will redirect to LOS login screen
      navigate(
        `/${logoutVal?.source}/${logoutVal?.anchor}/${logoutVal?.program}`,
        {
          replace: true,
        }
      );
    }
  };

  const handleClick = (event) => {
    setanchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setanchorEl(null);
  };

  useEffect(() => {
    (async () => {
      let getThemeVal = getRecoilVal(constant.atomsName.APP_THEME);

      document.documentElement.setAttribute(
        "color-scheme",
        getThemeVal || constant.LIGHT_THEME
      );
      setDarkMode(getThemeVal === constant.DARK_THEME && true);
    })();
  }, []);

  const handleThemeChange = (e) => {
    if (e.target.checked) {
      document.documentElement.setAttribute(
        "color-scheme",
        constant.DARK_THEME
      );
    } else {
      document.documentElement.setAttribute(
        "color-scheme",
        constant.LIGHT_THEME
      );
    }
    setRecoilVal(
      constant?.atomsName?.APP_THEME,
      e.target.checked ? constant.DARK_THEME : constant.LIGHT_THEME
    );
    setDarkMode(e.target.checked || false);
  };

  return (
    <>
      <div
        className="header_Th"
        style={{
          // backgroundColor: "rgb(1 9 56)",
          position: "fixed",
          width: "100%",
          inset: "0 0 auto auto",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            backgroundColor: "#29417c",
            maxWidth: "425px",
            margin: "auto",
            display: "flex",
            alignItems: "center",
            paddingTop: "10px",
            // gap: "8px",
            position: "relative",
          }}
        >
          {/* <Box
            sx={{
              width: "100%",
              maxWidth: "425px",
              // ml: -3,
              height: 35,
              bgcolor: "#f7f9ff",
              // bgcolor: "red",
              position: "fixed",
              borderRadius: "55px 55px 0 0",
              top: "9%",
              zIndex: 1,
            }}
          ></Box> */}
          <Box
            sx={{
              width: "100%",
              // maxWidth: "425px",
              // ml: -3,
              height: 21,
              bgcolor: "#29417c",
              // bgcolor: "green",
              position: "absolute",
              // borderRadius: "40%",
              borderRadius: "0 0 50px 50px",
              top: "58px",
            }}
          ></Box>

          <div
            // style={{ marginLeft: "20px", visibility: "hidden" }}
            style={{ marginLeft: "20px" }}
            onClick={() => !disabledBackBtn && navigate(-1)}
          >
            <ArrowBackIosNewOutlinedIcon
              style={{
                color: "white",
                opacity: disabledBackBtn ? "0.3" : "1",
                cursor: !disabledBackBtn ? "pointer" : "not-allowed",
              }}
            />
            {/* <img
            src="/assets/back.svg"
            alt=""
            style={{
              opacity: disabledBackBtn ? "0.3" : "1",
              cursor: !disabledBackBtn ? "pointer" : "not-allowed",
            }}
          /> */}
          </div>
          <div
          // style={{
          //   backgroundImage: "radial-gradient(circle,white, rgb(66 66 66))",
          //     // rgb(92, 99, 101))",
          //   paddingLeft: "10px",
          //   paddingRight: "10px",
          //   boxShadow: "1px 2px 3px rgba(0,0,0,.5)",
          // }}
          >
            <img
              src="/assets/logoTygerCapitalWhite.png"
              style={{
                width: "120px",
                height: "42px",
                marginLeft: "-10px",
              }}
              alt=""
            />
          </div>
          {/* <FormControlLabel
          control={
            <ThemeMaterialUISwitch
              checked={darkMode}
              sx={{
                m: 1,
                ml: 15,
                display: showLogoutBtn && displayLogoutBtn() ? "none" : "flex",
              }}
              onChange={handleThemeChange}
            />
          }
        /> */}
          {showMenu && (
            <div
              style={{ marginLeft: "155px" }}
              arial-label="app"
              color="inherit"
              id="demo-positioned-button"
              aria-controls={open ? "demo-positioned-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            >
              <MenuIcon style={{ color: "white", marginRight: "30px" }} />
              {/*<svg color="rgb(94 112 204)" viewBox="0 0 100 80" width="28" height="35">*/}
              {/*    <rect  width="100" height="18"></rect>*/}
              {/*    <rect y="30" width="100" height="18" ></rect>*/}
              {/*    <rect y="60" width="100" height="18"></rect>*/}
              {/*</svg>*/}
              {/* <img src="/assets/back.svg" alt="" />*/}
            </div>
          )}
          <Menu
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchororigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformorigin={{
              vertical: "top",
              horizontal: "left",
            }}
            MenuListProps={{ "aria-labelledby": "demo-positioned-button" }}
          >
            {/*<MenuItem onClick={handleClose}> Stages </MenuItem>*/}
          </Menu>
          {/* {showBar && (
            <Box className="progressBarContainer">
              <div
                className="progressBar"
                style={{
                  width: "" + (step / 16) * 100 + "%",
                }}
              />
            </Box>
          )} */}
          {/* logout button starts here */}

          <Box
            sx={{
              width: "100%",
              // display: showLogoutBtn && displayLogoutBtn() ? "flex" : "none",
              display: "flex",
              justifyContent: "end",

              marginRight: "20px",
            }}
          >
            {/* <Tooltip title="Profile"> */}
            <IconButton
              onClick={handleClick}
              size="small"
              // sx={{ ml: 20 }}
              aria-controls={open ? "account-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              <MenuIcon
                className="headerMenuIcon_Th"
                style={{ color: "white" }}
              />
            </IconButton>
            {/* </Tooltip> */}
          </Box>

          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              className: "header_Th typo_Th",
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <MenuItem
              onClick={() => navigate("/contactUs")}
              src="/assets/contactUsBG.png"
              width={30}
              height={30}
              alt="contact us"
              title="Contact Us"
              sx={{
                color: "black",
                mr: "10px",
                cursor: "pointer",
                display:
                  showContactUs && showLogoutBtn && displayLogoutBtn()
                    ? "block"
                    : "none",
              }}
            >
              <ListItemIcon>
                <SupportAgentIcon fontSize="small" />
              </ListItemIcon>
              Contact Us
            </MenuItem>

            <Divider
              sx={{
                display:
                  showContactUs && showLogoutBtn && displayLogoutBtn()
                    ? "block"
                    : "none",
              }}
            />

            <MenuItem
              onClick={handleLogout}
              sx={{
                color: "black",
                display: showLogoutBtn && displayLogoutBtn() ? "block" : "none",
              }}
            >
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              Logout
            </MenuItem>

            <Divider
              sx={{
                display: showLogoutBtn && displayLogoutBtn() ? "block" : "none",
              }}
            />

            <MenuItem onChange={handleThemeChange}>
              <ListItemIcon>
                <FormControlLabel
                  control={
                    <ThemeMaterialUISwitch
                      // sx={{ m: 1, ml: 15 }}
                      // onChange={handleThemeChange}
                      checked={darkMode}
                      disabled
                    />
                  }
                  label="Theme"
                />
              </ListItemIcon>
            </MenuItem>
          </Menu>
        </div>
      </div>
    </>
  );
}
